import GameUtil from '../utility/game_util';
import Debug from "./debug";
import AppData from '../pacakge/public/const/app_data';



export default class LanguageManager {

    private static _textChineseData

    private static _curLang = ""

    private static _sysLang = ""

    static _curFont = null

    private static _polyInst

    static init (language) {
        //zh-hans-cn th-th
        if (cc.sys.languageCode == "zh-cn" || cc.sys.languageCode == "zh-hans-cn") {
            LanguageManager._sysLang = "cn"
        } else {
            LanguageManager._sysLang = "th"
        }
        cc.log("languageCode", cc.sys.languageCode, cc.sys.language, LanguageManager._sysLang)
        if (language === LanguageManager._curLang) {
            return;
        }
        LanguageManager._curLang = language
        LanguageManager.loadLanguageData(language)
    }

    static change() {
        let ch = LanguageManager._curLang == "cn" ? "th" : "cn"
        this.init(ch)
    }

    static loadLanguageData (language) {
        GameUtil.loadRes("i18n/language", (error: Error, asset: cc.JsonAsset) => {
            if (error) {
                cc.log(error)
                return
            }
            // cc.log("LanguageManager asset.:",asset.json,asset);
            LanguageManager._polyInst = asset.json;
        })
    }

    private static _fontList :{} = {}
    static loadFont (lang,callback) {
        lang = lang || "cn"
        if( !this._fontList.hasOwnProperty(lang) ){
            GameUtil.loadRes("font/"+lang, (error: Error, asset: cc.Font) => {
                if (error) {
                    LanguageManager._curFont = null
                    if(callback){
                        callback()
                    }
                    cc.log(error)
                }else{
                    LanguageManager._curFont = asset
                    this._fontList[lang] = asset
                    if(callback){
                        callback()
                    }
                }
               
                
            })
        }else{
            LanguageManager._curFont = this._fontList[lang]
            if(callback){
                callback()
            }
        }
        
    }

    static t(key : string, debugShowChinese ?: boolean) {
        let langMap =  LanguageManager._polyInst[key];
        if (!langMap) {
            cc.error("LanguageManager 找不到 key " + key);
            return key;
        }
        let content
        // if (debugShowChinese && LanguageManager._sysLang == "cn") {
        if (debugShowChinese && AppData.testMode) {
            content = (langMap[LanguageManager._curLang] || key) + "(" + langMap["cn"] + ")"
            // content = langMap["cn"] || key
        } else {
            content = langMap[LanguageManager._curLang] || key
        }
        if (CC_PREVIEW) {
            
        }
        return content
    }

    //会自动更加当
    static k(key : string) {
        let langMap =  LanguageManager._polyInst[key];
        if (!langMap) {
            cc.error("LanguageManager 找不到 key " + key);
            return key;
        }
        return langMap[LanguageManager._sysLang] || langMap[LanguageManager._curLang]
    }
}